import React from 'react'

const WalletList = () => {
  return (
    <div className=''>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200'>My List</a></div>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200'>Wish List</a></div>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200'>Legal Information</a></div>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200'>Need Help</a></div>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200'>Contact Us</a></div>
          <div className='w-full'><a href="/alloffers" className='text-sm px-3 font-semibold text-gray-700 py-4 block '>Logout</a></div>
        
    </div>
  )
}

export default WalletList